<template>
    <div class="review-component" :class="`review-component-${component.type}`">

<!--        <span v-if="false">{{component.type}} - {{component.displayName}}</span>-->
        <slot></slot>

        <span class="review-status" v-if="component.review">
            <span v-for="(error, index) in component.review" :key="`${component.id}-${index}}`">
                <e-status-badge :status="error.status">
                    {{error.message}}
                </e-status-badge>
            </span>
        </span>
    </div>
</template>

<script>
import EStatusBadge from "@vue-components/components/e-status-badge.vue";

export default {
    name: `review-component`,
    components: {EStatusBadge},
    props: {
        component: { type: Object, required: true }
    }
}
</script>

<style lang="scss">
</style>
